import { type RouterOutputs } from './trpc';

export type Profile = RouterOutputs['users']['publicDetails'];

export type SearchedProfile = RouterOutputs['search']['users']['users'][0];

export type Moderator = RouterOutputs['spaces']['moderators']['users'][0];

export type MinUserDTO = RouterOutputs['users']['followersList']['users'][0];

export enum FollowersListModalType {
  FOLLOWERS = 'Followers',
  FOLLOWING = 'Following'
}
